import { IndicatorType } from '../constants/common'
import { ExponentialMovingAverage } from './ema'
import { MainCalculation, OnValueCalculated } from './main'

type Options = {
  period: number
}

type DefaultCalculatedValuesType = {
  trix: number[]
}

export class TrixCalculation extends MainCalculation<Options, DefaultCalculatedValuesType> {
  static type = IndicatorType.Trix

  getDefaultCalculatedValues() {
    return { trix: [] }
  }

  calculate(onValueCalculated?: OnValueCalculated<typeof this.calculatedValues>) {
    const { period } = this.options
    const { close } = this.quote
    const lastIndex = close.length - 1
    const ema1 = new ExponentialMovingAverage(period)
    const ema2 = new ExponentialMovingAverage(period)
    const ema3 = new ExponentialMovingAverage(period)
    this._calculatedValues = this.getDefaultCalculatedValues()

    let prev = 0
    for (let index = 0; index <= lastIndex; index++) {
      ema1.add(close[index])
      ema2.add(ema1.value)
      ema3.add(ema2.value)
      if (prev > 0) {
        this.calculatedValues.trix[index] = (ema3.value * 100) / prev - 100
      }
      prev = ema3.value

      if (onValueCalculated?.(this.calculatedValues, index) === false) {
        break
      }
    }
  }
}
